import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

declare global {
  interface Window {
    dataLayer: unknown[];
    gtag: (...args: unknown[]) => void;
  }
}

const getGAMeasurementId = (): string => {
  if (typeof window === 'undefined') return 'G-5674JVJDWF';
  
  const hostname = window.location.hostname;
  
  if (hostname === 'carbonwize.io' || hostname === 'www.carbonwize.io') {
    return 'G-DGB1686JQW'; // Production
  } else if (hostname.includes('uat') || hostname.includes('staging')) {
    return 'G-90ZC6M2W9R'; // UAT
  } else {
    return 'G-5674JVJDWF'; // Development
  }
};

const GoogleAnalytics = () => {
  const location = useLocation();
  const measurementId = getGAMeasurementId();

  useEffect(() => {
    // Load gtag script dynamically
    const script = document.createElement('script');
    script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
    script.async = true;
    document.head.appendChild(script);

    // Initialize gtag
    window.dataLayer = window.dataLayer || [];
    window.gtag = function gtag(...args: unknown[]) {
      window.dataLayer.push(args);
    };
    window.gtag('js', new Date());
    window.gtag('config', measurementId);

    return () => {
      document.head.removeChild(script);
    };
  }, [measurementId]);

  // Track page views on route change
  useEffect(() => {
    if (window.gtag) {
      window.gtag('config', measurementId, {
        page_path: location.pathname + location.search,
      });
    }
  }, [location, measurementId]);

  return null;
};

export default GoogleAnalytics;
